import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getHttpHeader } from './../../../utils/http-header.factory';
import { BaseService } from '../../../templates/services/base-service.template';
import { Core2Config } from './../../../utils/core2-config';
import { ApiResponseModel } from './../../../models/base/api-response.model';
import { ApiVisa } from './../../../models/base/apivisa.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionAssigneeTargetService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.UNIPIN_PREFIX + 'shared/get-app-perm-assignee-target-link-guid';

  constructor(protected readonly http: HttpClient) {}

  public getAssigned(perm_set_hdr_guids: string[], applet_hdr_guid: string, assignee_hdr_guid: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<string[]>>{
    return this.http.post<ApiResponseModel<string[]>>(`${ api_domain_url }${ this.apiUrl }`, {
      applet_hdr_guid,
      assignee_hdr_guid,
      perm_set_hdr_guids
    }, getHttpHeader(jwt_secret, tenantCode));
  }
}
